export class StickyCollapsed {

    public lastPos:number|undefined;

    constructor () {
        $(window).on("load scroll", (ev)=>this.scrollEvent(ev));
    }

    private scrollEvent(ev:JQuery.Event) {
        var scrollTop=$(window).scrollTop()??-1;
        if (scrollTop < 0 ) return;
        if (scrollTop === this.lastPos) return;
        // Math.max zum abfangen verschiedener Cross-Browser Problemen
        var limit = Math.max(document.body.scrollHeight,document.body.offsetHeight,document.documentElement.clientHeight,document.documentElement.scrollHeight,document.documentElement.offsetHeight) - window.innerHeight;
        if (scrollTop >= limit) return;

        $('html').toggleClass('sticky',scrollTop>0);
        $('html').toggleClass('collapsed', (this.lastPos??0) < scrollTop);
        this.lastPos = scrollTop;
    }
}
new StickyCollapsed();

export {};